import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {ButtonGroup , Tooltip, Button, Menu, CircularProgress, MenuItem, ListItemText, useTheme } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Alert, AuditView} from "../../";
import useStyles from './styles';
import { getMuiTheme } from "./styles";
import { ActionPopup } from "./components";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { pathOr } from "ramda";
import { toast } from "react-toastify";
import { getNotifications } from "../../../store/actions/dashboard.actions";
import { deleteRecordFromModule } from '../../../store/actions/module.actions';
import { printAsPdf,emailCustomerReview } from '../../../store/actions/detail.actions';
import { exportReport, downloadReportPdf } from "../../../store/actions/aor_reports.actions";
import {massUpdate,getListView} from "../../../store/actions/module.actions";
import { AddToTargetListModal } from "../../ReportDataView/components/CustomToolbarSelect/components";
import {emailAsPdf } from "../../../store/actions/emails.actions";
import { QuickComposeEmail } from "../../Emails/components";

import { saveAs } from 'file-saver';
const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

export default function MoreActionButton(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const currentTheme = useTheme();
  const { selectedModule } = useSelector((state) => state.modules);
  const config = useSelector((state) => state.config);
  const rowsPerPage = pathOr(20, ['config','list_max_entries_per_page'], config);

  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [addToTargetModalVisible, setAddToTargetModalVisible] = useState(false);
  const [actionPopupOpen, setActionPopupOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [actionName, setActionName] = useState(null);
  const [emailModalVisible, setEmailModalVisible] = useState(false);
  const { emailCreateViewLoading } = useSelector((state) => state.emails);
  const [auditViewPopup, setAuditViewPopup] = useState(false);

  const site_url = pathOr("",["config", "site_url"],useSelector((state) => state.config));
  const userData = pathOr(undefined,["data", "attributes"],useSelector((state) => state.config.currentUserData));
  const [alertInfo, setAlertInfo] = useState({ title: "", msg: "", visible: false, action: "" });

  const buildPayloadForMassUpdate = (action, type, id, attributes = [], prospect_list = "") => ({
    action,
    data: {
      type,
      id,
      attributes,
      prospect_list
    },
  });

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const exportReportAction = async () => {
    try {
      setAlertInfo((prev) => ({ ...prev, visible: false }));
      const payload = { report_id: props.record }
      toast("exporting in progress...");
      let res = await exportReport(payload);
      if (res.ok) {
        setLoading(false);
        dispatch(getNotifications(1, userData.id));
        toast("Report exported successfully, check notifications section for the download link.");
      } else {
        toast(res.data.errors.detail);
      }
    } catch (e) {
      setAlertInfo((prev) => ({ ...prev, visible: false }));
      toast("something went wrong! please try again.");
    }
  }

  const downloadReportPdfAction = async () => {
    try {

      setAlertInfo((prev) => ({ ...prev, visible: false }));
      const payload = { report_id: props.record }
      toast("downloading in progress...");
      let res = await downloadReportPdf(payload);
      if (res.ok) {
        setLoading(false);
        dispatch(getNotifications(1, userData.id));
        toast("Report downloaded successfully, check notifications section for the download link.");

      } else {
        toast(res.data.errors.detail);
      }
    } catch (e) {
      setAlertInfo((prev) => ({ ...prev, visible: false }));
      toast("something went wrong! please try again.");
    }
  }

  const addIdToTargetList = async (propspectListId) => {
    try {
      setLoading(true);
      let recordsToBeAddedIds = [props.record];
      const payload = buildPayloadForMassUpdate(
        "addToTargetList",
        props.module,
        recordsToBeAddedIds,
        [],
        propspectListId
      );
      let res = await massUpdate(payload);
      if (res.ok) {
        setLoading(false);
        setAlertInfo((prev) => ({ ...prev, visible: false }));
        toast("added to target list successfully!");
        dispatch(getListView(props.module,0,rowsPerPage));

      } else {
        setAlertInfo((prev) => ({ ...prev, visible: false }));
        toast(res.data.errors.detail);

      }
    } catch (e) {
      setAlertInfo((prev) => ({ ...prev, visible: false }));
      toast("something went wrong! please try again.");
    }
  }


  const deleteRecord = async () => {
    try {
      const res = await deleteRecordFromModule(props.module, props.record);
      setAlertInfo((prev) => ({ ...prev, visible: false }));
      toast(res.ok ? res.data.meta.message : res.data.errors.detail);
      history.push("/app/" + props.module);

    } catch (e) {
      toast("something went wrong! please try again.");
    }
  };

  const emailCustomerReviewAction = async () => {
    try {
      handleClose();
      setAlertInfo((prev) => ({ ...prev, visible: false }));
     
      toast("Send for customer review is in progress...");
     // let res = await emailCustomerReview(payload);
      dispatch(emailCustomerReview(props.module,props.record)).then(function (res) {
        console.log("res",res);
        setLoading(false);
        toast("Success! Sent for customer review.");
      }); 
    } catch (e) {
      console.log("error emailCustomerReviewAction",e);
      setAlertInfo((prev) => ({ ...prev, visible: false }));
      toast("something went wrong!");
    }
  }

  useEffect(() => {
    if (actionName === 'LBL_PRINT_AS_PDF') {
      setAnchorEl(null);

      setAlertInfo((prev) => ({ ...prev, title: "Print as PDF", msg: "Are you sure you want to download this as PDF?", visible: true, action: printAsPdfAction }));
      setActionName(null);
      setSelectedValue(null);
      setActionPopupOpen(false)


    } else if (actionName === 'LBL_EMAIL_PDF' || actionName === 'LBL_EMAIL_QUOTE') {

      const payload = {
        module: props.module, report_id: props.record, extraTask: actionName === 'LBL_EMAIL_QUOTE' ? 'email' : 'emailpdf',
        templateId: selectedValue
      }


      // dispatch(getEmailCreateView()).then(function () {
      dispatch(emailAsPdf(payload)).then(function (res) {
        // emailAsPdfAction('emailpdf')
        setEmailModalVisible(!emailModalVisible);
        setAnchorEl(null);
        setActionName(null);
        setSelectedValue(null);
        setActionPopupOpen(false)
      });
    }
    // else 
    // if (actionName === 'LBL_EMAIL_QUOTE') {
    //   dispatch(getEmailCreateView()).then(function () {
    //     emailAsPdfAction('emailpdf')
    //     setEmailModalVisible(!emailModalVisible);
    //     setAnchorEl(null);
    //     setActionName(null);
    //     setSelectedValue(null);
    //     setActionPopupOpen(false)

    //   });

    // }
  }, [selectedValue])

  // const emailAsPdfAction = async (extraTask) => {
  //   try {
  //     console.log(actionName, selectedValue, actionPopupOpen)
  //     const payload = {
  //       module: props.module, report_id: props.record, extraTask: extraTask,
  //       templateId: selectedValue
  //     }
  //     let res = await printAsPdf(payload);
  //     if (res.ok) {
  //       setLoading(false);
  //       console.log('emailpdf', res)
  //     } else {
  //       toast(res.data.errors.detail);
  //     }

  //   } catch (e) {
  //     toast("something went wrong! please try again.");
  //   }
  // }


  const printAsPdfAction = () => {
    try {
      setAlertInfo((prev) => ({ ...prev, visible: false }));
      const payload = {
        module: props.module, report_id: props.record, extraTask: "pdf",
        templateId: selectedValue
      }
      toast("downloading in progress...");
      dispatch(printAsPdf(payload)).then(function (res) {
        setLoading(false);

        const n = pathOr("", ["data", "attributes", "url_redirect"], res).lastIndexOf('/');
        const filename = pathOr("", ["data", "attributes", "url_redirect"], res).substring(n + 1);
        
        saveAs(`${site_url}/${pathOr("", ["data", "attributes", "url_redirect"], res)}`, filename); 

        toast("PDF downloaded successfully, check notifications section for the download link.");


      })

    } catch (e) {
      setAlertInfo((prev) => ({ ...prev, visible: false }));
      toast("something went wrong! please try again.");
    }

  }
  
  
  const renderActionButtons = () => {
    return props.actionButtons.map((action, key) => {
      let actions = {};
      actions.actionName = action.label;
      switch (action.key) {
        case ("EDIT"):
          actions.onClick = () => history.push("/app/editview/" + props.module + "/" + props.record);
          break;
        case ("DELETE"):
          actions.onClick = () => setAlertInfo((prev) => ({ ...prev, title: "Delete Record", msg: "Are you sure you want to delete this record?", visible: true, action: deleteRecord }));
          break;
        case ("DUPLICATE"):
          actions.onClick = () => history.push("/app/duplicateview/" + props.module + "/" + props.record);
          break;
        case ("FIND_DUPLICATES"):
          actions.onClick = () => toast("No action found!");
          break;
        case ("CHANGE_LOG"):
          actions.onClick = () => setAuditViewPopup(!auditViewPopup);
          break;
        case ("LBL_CONVERTLEAD"):
          actions.onClick = () => history.push("/app/convertlead/Leads/" + props.record);
          break;
        case ("LBL_GENERATE_LETTER"):
          actions.onClick = () => toast("No action found!");
          break;
        case ("Create"):
        case ("CREATE"):
          actions.onClick = () => history.push("/app/createview/" + props.module);
          break;

        case ("LBL_EXPORT"):
          actions.onClick = () => setAlertInfo((prev) => ({ ...prev, title: "Export Report", msg: "Are you sure you want to export report?", visible: true, action: exportReportAction }));
          break;
        case ("LBL_DOWNLOAD_PDF"):
          actions.onClick = () => setAlertInfo((prev) => ({ ...prev, title: "Download Report as PDF", msg: "Are you sure you want to download report as PDF?", visible: true, action: downloadReportPdfAction }));
          break;
        case ("LBL_ADD_TO_PROSPECT_LIST"):
          actions.onClick = () => setAddToTargetModalVisible(!addToTargetModalVisible);
          break;

        case ("LBL_PRINT_AS_PDF"):
          actions.onClick = () => (setActionPopupOpen(true), setActionName('LBL_PRINT_AS_PDF'))
          break;
        case ("LBL_EMAIL_PDF"):
          actions.onClick = () => (setActionPopupOpen(true), setActionName('LBL_EMAIL_PDF'))
          break;
        case ("LBL_EMAIL_QUOTE"):
          actions.onClick = () => (setActionPopupOpen(true), setActionName('LBL_EMAIL_QUOTE'))
          break;
        case ("LBL_CREATE_OPPORTUNITY"):
        case ("LBL_CREATE_CONTRACT"):
          actions.onClick = () => () => toast("No action found!");
          break;

        case ("LBL_CONVERT_TO_INVOICE"):
          actions.onClick = () => history.push("/app/convert/AOS_Invoices/" + props.record + "/AOS_Quotes");
          break;
        case ("LBL_EMAIL_CUSTOMER_REVIEW"):
            actions.onClick = () => setAlertInfo((prev) => ({ ...prev, title: "Send for Customer Review", msg: "Are you sure you want to Send for Customer Review?", visible: true, action: emailCustomerReviewAction }));
            break;
          
        default:
          actions.onClick = () => toast("No action found!");
          break;
      }
      return (<StyledMenuItem onClick={actions.onClick}>
        <ListItemText primary={actions.actionName} />
      </StyledMenuItem>);
    });
  }


  return (
    <MuiThemeProvider theme={getMuiTheme(currentTheme)}>
      
      {
        <>
        
          {
            props.actionButtons && props.actionButtons.length &&
            <>
            <ButtonGroup variant="contained" color="primary" ref={anchorEl} aria-label="split button" className={classes.moreActionBtn}>
              {
                props.actionButtons[0].key==='EDIT' ?
                <Tooltip title={"Edit Record"} arrow placement="bottom">
                  <Button className={classes.moreActionBtn} color="primary" size="small" onClick={() => history.push("/app/editview/" + props.module + "/" + props.record)}>EDIT</Button>
                </Tooltip>:
                <Tooltip title={"More Action"} arrow placement="bottom">
                  <Button className={classes.moreActionBtn} color="primary" size="small" aria-controls={Boolean(anchorEl) ? 'split-button-menu' : undefined} aria-expanded={Boolean(anchorEl) ? 'true' : undefined} aria-label="select merge strategy" aria-haspopup="menu" onClick={handleClick}>ACTION</Button>
                </Tooltip>
              }
              <Tooltip title={"More Action"} arrow placement="bottom">
                <Button className={classes.moreActionCaretBtn} color="primary" size="small" aria-controls={Boolean(anchorEl) ? 'split-button-menu' : undefined} aria-expanded={Boolean(anchorEl) ? 'true' : undefined} aria-label="select merge strategy" aria-haspopup="menu" onClick={handleClick}>
                  <ArrowDropDownIcon fontSize="small" />
                </Button>
              </Tooltip>
            </ButtonGroup>
            <StyledMenu id="more-action" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
              {renderActionButtons()}
            </StyledMenu>
            </>
          }
          {addToTargetModalVisible && (
            <AddToTargetListModal
              modalVisible={addToTargetModalVisible}
              toggleModalVisibility={() =>
                setAddToTargetModalVisible(!addToTargetModalVisible)
              }
              addIdToTargetList={addIdToTargetList}
              selectedModule={selectedModule}
            />
          )}

          {auditViewPopup && (
            <AuditView
              modalVisible={auditViewPopup}
              toggleModalVisibility={() =>
                setAuditViewPopup(!auditViewPopup)
              }
              module={props.module}
              record={props.record}
            />
          )}
          <Alert
            title={alertInfo.title}
            msg={alertInfo.msg}
            open={alertInfo.visible}
            agreeText={loading ? <CircularProgress /> : "Yes"}
            disagreeText={!loading && "No"}
            handleClose={() => setAlertInfo({ visible: false })}
            onAgree={() => alertInfo.action()}
          />
          {actionPopupOpen ? <ActionPopup actionName={actionName} module={props.module} selectedValue={selectedValue} setSelectedValue={setSelectedValue}
            actionPopupOpen={actionPopupOpen} setActionPopupOpen={setActionPopupOpen} /> : null}
          {emailModalVisible && !emailCreateViewLoading ? (<QuickComposeEmail
            modalState={emailModalVisible}
            handleClose={() => { setEmailModalVisible(!emailModalVisible); }}
          />) : null}

        </>
          }
    </MuiThemeProvider>
  );
}
